<template>
  <div class="new-application">
    <el-card class="box-card">
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">基本信息</span>
      </div>
      <div>
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
          :disabled="!isEdit"
          @cancelForm="cancel"
          ref="form"
        />
      </div>
      <div class="button">
        <el-button
          class="btn-cancel"
          v-if="isEdit"
          :loading="loading"
          @click="save(1)"
          >保存</el-button
        >
        <el-button
          class="btn-submit"
          v-if="isEdit"
          :loading="loading"
          @click="submit(2)"
          >提交</el-button
        >
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
      <!-- <drag-dialog :show="dialogShow" :title="'审批人选择'" :width="'50%'" @close="close">
        <dynamic-form
          labelWidth="110px"
          :formConfig="dialogForm"
          v-model="form2"
          :showBtn="true"
          :showSaveBtn="false"
          :disabled="false"
          @submit="submitConfirm(2)"
          @cancelForm="dialogShow=false"/> />
      </drag-dialog> -->
      <drag-dialog
        :show="stepShow"
        :title="'审批人选择'"
        :width="'25%'"
        @close="close"
      >
        <PersonStep
          :data="personStepData"
          @submit="submitConfirm"
          @close="close"
        ></PersonStep>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form";
import { addUse, updateUse, useDetails, } from "@/api/bill/ResourceUse";
import { getDocumentCode } from '@/views/utils'
import DragDialog from "@/components/DragDialog"
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";

export default {
  name: "ResourceUseFrom",
  components: { DragDialog, PersonStep },
  data () {
    return {
      id: "",
      loading: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            label: "项目号",
            key: "project",
            type: "databox",
            placeholder: "请选择项目",
            span: 8,
            props: {
              label: "code",
              value: "code"
            },
            url: '/resourceRorrowing/getProject',
            tableColumn: [
              {
                property: "code",
                label: "项目号",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: {},
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "项目名",
            key: "projectName",
            type: "input",
            span: 8,
            disabled: true
          },
          {
            label: "人员",
            key: "staff",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "",
            tableColumn: [
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { projectNum: '' },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            },
            disabled: true
          },
          {
            type: "input",
            key: "personCode",
            label: "工号",
            placeholder: "请输入工号",
            value: "",
            span: 8,
            disabled: true
          },
          // {
          //   type: "input",
          //   key: "rawOccupyProjectNum",
          //   label: "原占用项目号",
          //   value: "",
          //   span: 8,
          //   disabled: true
          // },
          // {
          //   type: "input",
          //   key: "rawApplyforPmName",
          //   label: "原项目经理",
          //   value: "",
          //   span: 8,
          //   disabled: true
          // },
          {
            type: "input",
            key: "rank",
            label: "职级",
            placeholder: "请输入职级",
            value: "",
            span: 8,
            disabled: true
          },
          {
            type: "number",
            key: "settleAccountUnitPrice",
            label: "结算单价",
            placeholder: "请输入结算单价",
            value: "",
            span: 8,
            disabled: true,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            },
          },
          // {
          //   type: "date",
          //   key: "startDate",
          //   label: "起始日期",
          //   placeholder: "请选择起始日期",
          //   value: "",
          //   span: 8,
          //   rules: {
          //     required: true,
          //     message: "起始时间不能为空",
          //     trigger: "change"
          //   }
          // },
          // {
          //   type: "date",
          //   key: "dateClosed",
          //   label: "结束日期",
          //   placeholder: "请选择结束日期",
          //   value: "",
          //   span: 8,
          //   rules: {
          //     required: true,
          //     message: "结束时间不能为空",
          //     trigger: "change"
          //   }
          // },
          {
            type: "databox",
            key: "projectRoles",
            label: "项目角色",
            placeholder: "请输入项目角色",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bsProjectRoles",
            tableColumn: [
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "stakeholder",
                label: "权益方",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "remark",
                label: "备注",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,name" },
            multiple: false,
            rules: {
              required: true,
              message: "项目角色不能为空",
              trigger: "change"
            }
          },
          // {
          //   type: "number",
          //   key: "workManDay",
          //   label: "工作人天估算",
          //   placeholder: "请输入工作人天估算",
          //   value: "",
          //   span: 8,
          //   rules: {
          //     required: true,
          //     message: "工作人天不能为空",
          //     trigger: "blur"
          //   }
          // },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注",
            span: 18,
          }
        ],
        changeFlag: false,
      },
      staffId: '',
      isEdit: false,
      dialogShow: false, // 提交弹窗
      dialogForm: {
        formItemList: []
      },
      form2: {}, // hr审批
      assignData: {}, // hr审批人员信息
      stepShow: false,
      personStepData: []
    };
  },
  watch: {
    'form.staff': {
      handler (val) {
        if (val && !this.id) {
          console.log('val....', val)
          this.form.personCode = val.code;
          this.form.rank = val.rankEntity ? val.rankEntity.code : '';
          this.form.settleAccountUnitPrice = val.rankEntity ? val.rankEntity.settlementUnitPrice : ''
        }
      },
      deep: true
    },
    "form.project": {
      handler (val) {
        if (val) {
          this.form.projectName = val.name;
          this.form.projectNumber = val.code;
          // this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'staff')],"url","/resourceRorrowing/getPerson")
          // this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'staff')],"extendParms",{ projectNum: val.code},)
        }
      },
    },
    "form.project.code": {
      handler (val) {
        if (val) {
          this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'staff')], "disabled", false)
          this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'staff')], "url", "/resourceRorrowing/getPerson")
          this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'staff')], "extendParms", { projectNum: val },)
        } else {
          //  return this.$notify({ title: '请先选择项目！', type: 'error', duration: 2500})
          this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'staff')], "disabled", true)
        }
      },
    },
  },
  created () {
    this.id = this.$route.params.id
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    if (this.id) {
      this.getDetail();
    } else {
      this.form.code = getDocumentCode('ZYJY')
    }
  },
  methods: {
    // 详情
    getDetail () {
      useDetails(this.id).then(res => {
        if (res.code === 200) {
          const form = res.data;
          form.project = { code: form.projectNumber, name: form.projectName }
          if (form.staffEntity) {
            form.staff = { name: form.staffEntity.name, code: form.personCode, rank: form.rank }
          }
          if (form.projectRoleEntity) {
            form.projectRoles = { name: form.projectRoleEntity.name, stakeholder: form.projectRoleEntity.stakeholder, }
          }
          this.form = form
        }
      });
    },
    // 保存
    save (status) {
      this.loading = true;
      this.pull(this.getFormData(status))
    },
    close () {
      this.stepShow = false;
    },
    submitConfirm (val) {
      this.loading = true
      const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      // console.log('rjuq..',obj)
      this.pull(obj)
    },
    // 提交
    submit (status) {
      this.loading = true;
      this.$refs.form.validate().then(() => {
        if (process.env.VUE_APP_IS_AUDIT === 'no') { // 判断是否需要走审批
          this.$confirm('请确认是否提交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const obj = this.getFormData(2)
            obj.billState = 3
            this.loading = true
            this.pull(obj)
          }).catch(() => {
            this.loading = false
          });
        } else {
          getFlowNode({ from: "Resource_use", id: this.form.id }).then(res => {
            this.loading = false;
            this.personStepData = [];
            if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
            }
          });
        }
      }).catch(e => { this.loading = false; })
    },
    cancel () {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    },
    getFormData (status) {
      this.form.billState = status;
      if (this.form.staff) {
        this.form.personId = this.form.staff.id
      }
      if (this.form.projectRoles) {
        this.form.projectRole = this.form.projectRoles.id
        this.form.projectRoleEntity = { id: this.form.projectRole };
      }
      if (status === 2) { // HR审批提交人信息
        this.form.from = "Resource_use"
        // this.form.assignData = JSON.stringify(this.assignData)
      }
      return this.form
    },
    pull (obj) {
      if (this.form.id) {
        updateUse(obj).then(res => {
          this.loading = false;
          if (res.code === 200) {
            this.$notify({ title: '操作成功！', type: 'success', duration: 2500 })
            // 保存
            if (obj.billState === 1) {
              const { path } = this.$route
              this.$store.dispatch('tagsView/delCachedView', this.$route).then(() => {
                this.$router.replace({
                  path: '/redirect' + path
                })
              })
            } else {
              this.cancel()
            }
          }
        }).catch(() => {
          this.loading = false;
        })
      } else {
        addUse(obj).then(res => {
          this.loading = false;
          if (res.code === 200) {
            this.$notify({ title: '操作成功！', type: 'success', duration: 2500 })
            // 保存
            if (obj.billState === 1) {
              const {path} = this.$route
              this.$store.dispatch('tagsView/delView', this.$route).then(() => {
                this.$router.replace({path: '/redirect' + `${path}/1/${res.data.id}`})
              })
            } else {
              this.cancel()
            }
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.content-title {
  height: 40px;
  background-color: #e7eff6;
  padding-left: 20px;
  overflow: hidden;
  .title-icon {
    display: inline-block;
    margin-top: 8px;
    width: 4px;
    height: 24px;
    background-color: #1369a8;
    margin-right: 14px;
  }
  .title-details {
    overflow: hidden;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-family: SourceHanSansSC-regular;
  }
}
.el-icon-back {
  padding-bottom: 10px;
}
.button {
  padding-top: 20px;
  text-align: right;

  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }

  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
</style>
